"use client";
import { useTranslation } from "@/lib/i18n";

import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { ArrowRightIcon } from "lucide-react";
import { Section } from "../ui/section";
import { Mockup, MockupFrame } from "../ui/mockup";
import Glow from "../ui/glow";
import Image from "next/image";
import { siteConfig } from "@/config/site";
import { useTheme } from "next-themes";

export default function Hero() {
  const { t } = useTranslation("common");
  const { resolvedTheme } = useTheme();
  let src;

  switch (resolvedTheme) {
    case "light":
      src = "/app-light.png";
      break;
    case "dark":
      src = "/app-dark.png";
      break;
    default:
      src = "/app-light.png";
      break;
  }

  return (
    <Section className="fade-bottom overflow-hidden md:py-24 pb-0 sm:pb-0 md:pb-0">
      <div className="mx-auto flex max-w-container flex-col gap-12 p-0 sm:gap-24">
        <div className="flex flex-col items-center gap-6 text-center sm:gap-14">
          <Badge variant="outline" className="animate-appear">
            <span className="text-muted-foreground">
              {t("hero.badge")}
            </span>
            <a
              href={siteConfig.links.learnMore}
              className="flex items-center gap-1"
            >
              {t("hero.learn_more")}
              <ArrowRightIcon className="h-3 w-3" />
            </a>
          </Badge>
          <h1 className="relative max-w-[1150px] z-10 inline-block animate-appear bg-gradient-to-r from-foreground to-foreground bg-clip-text text-4xl font-semibold leading-tight text-transparent drop-shadow-2xl sm:text-6xl sm:leading-tight md:text-8xl md:leading-tight dark:to-muted-foreground">
            {t("hero.title")}
          </h1>
          <p className="text-md relative z-10 max-w-[600px] animate-appear font-medium text-muted-foreground opacity-0 delay-100 sm:text-xl">
            {t("hero.subtitle")}
          </p>
          <div className="relative z-10 flex animate-appear justify-center gap-4 opacity-0 delay-300">
            <div className="relative z-10 flex animate-appear justify-center gap-4 opacity-0 delay-300">
              <Button variant="default" size="lg" asChild>
                <a href={siteConfig.bookDemoUrl}>{t("hero.book_demo")}</a>
              </Button>
              <Button variant="glow" size="lg" asChild>
                <a href={siteConfig.signUp}>{t("hero.sign_in")}</a>
              </Button>
            </div>
          </div>
          <div className="relative pt-12">
            <MockupFrame
              className="animate-appear opacity-0 delay-700"
              size="small"
            >
              <Mockup type="responsive">
                <Image
                  src={src}
                  alt="AI Compliance GRC platform dashboard"
                  width={1248}
                  height={765}
                  priority
                />
              </Mockup>
            </MockupFrame>
            <Glow
              variant="top"
              className="animate-appear-zoom opacity-0 delay-1000"
            />
          </div>
        </div>
      </div>
    </Section>
  );
}
